import React from 'react';
import PageContainer from '../components/PageContainer';
import ForceGraph from '../components/ForceGraph';
import PageContainerNoLogo from '../components/PageContainerNoLogo';

function Home() {
  return (
    <>
      <PageContainer>
        <h1>Welcome to Häl Music</h1>
        <p>
          HÄL Music is a cutting edge machine learning company that provides professional
          level mixing services at a fraction of the cost and time of traditional companies.
          Sign Up to get started.
        </p>
      </PageContainer>
      
      <PageContainerNoLogo>
        {/* Wrapper with position: relative to contain both the SVG and the overlay */}
        <div style={{ position: 'relative' }}>
            <section>
              <h1>Revolutionizing Music Mixing with Cutting-Edge Technology</h1>
              <p1>We’re bringing a groundbreaking transformation to the world of music mixing. Our innovative approach combines advanced machine learning and signal processing to automate and elevate the mixing process in ways never seen before.</p1>

              <h3>Smart Sound Optimization</h3>
              <p1>Our technology can analyze your tracks and identify the exact tools needed—like equalizers, compressors, and reverb—while eliminating anything unnecessary. This ensures every element in your mix is perfectly balanced, saving time and enhancing creative control.</p1>

              <h3>Noise Correction and Balancing</h3>
              <p1>Using techniques inspired by cutting-edge AI methods, our system identifies and corrects imbalances in volume, frequency, and tone. It works seamlessly to clean up imperfections and produce a mix that feels polished, professional, and tailored to your sound.</p1>

              <h3>Adaptive Intelligence</h3>
              <p1>Every mix is unique, and so is our approach. Our technology doesn’t just follow static rules—it adapts dynamically to the specific needs of your music, creating mixes that sound great across all environments while preserving your artistic vision.</p1>

              <p1>This next-generation technology is designed to empower music creators, enabling them to focus on their artistry while we handle the technical details. Whether you’re a seasoned professional or just starting out, our tools ensure that your music sounds its absolute best.</p1>
            </section>

            {/* Spacer added below text section */}
            <div style={{ marginBottom: '20px' }}></div> 

            <ForceGraph />
        </div>
      </PageContainerNoLogo>
    </>
  );
}

export default Home;
